import script from "./Search.vue?vue&type=script&setup=true&lang=ts"
export * from "./Search.vue?vue&type=script&setup=true&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=54c94cd8&lang=css"

const __exports__ = script;

export default __exports__